import { createRouter, createWebHashHistory } from "vue-router";
//@ts-ignore
import GameScreen from "../views/GameScreen/index.vue";
//@ts-ignore
import Home from "../views/Home/index.vue";
import gameApplication from "../game/game-app";
import { GameStage } from "../types/game-stage-enum";
import { useStore } from "../stores";
import AppConfig from "../config/app-config";

/**
 * This is to define UI routers.
 */
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      component: Home,
      name: 'home',
      beforeEnter: (to, from) => {
        const store = useStore();

        if (from.name === 'game') {
          if (gameApplication.requestId !== undefined) {
            gameApplication.stopAnimate(); // draw the menu 
          }

          if (gameApplication.getGameKind() === 'PRACTICE') {
            store.state.isRoomsShown = false;
          } else {
            store.state.isRoomsShown = false;
          }

          if (gameApplication.getGameStage() === GameStage.GameInProgress) {
            if (gameApplication.getGameKind() !== 'PRACTICE') {
              gameApplication.sendLeaveGameMessage();
            } else {
              // Emit "end game" event to the Vue.js front end.
              gameApplication.fireEvent('END_GAME');   
            }
          }

          if (gameApplication.getGameStage() !== GameStage.RoomChoosing) {
            gameApplication.setGameStage(GameStage.RoomChoosing);
            gameApplication.leaveRoom();
            gameApplication.setGameKind('');
            store.state.selectedRoomId = '';
          }
        }

        // accept the navigation
        return true;
      },
    },

    {
      path: '/game',
      component: GameScreen,
      name: 'game',
      beforeEnter: (to, from) => {
        if (gameApplication.getGameKind() === undefined && to.query.mode !== 'practice') {
          window.location.href = AppConfig.WEB_SITE_PLAY_PAGE;
        }

        // accept the navigation
        return true;
      },
    },
  ],
});

export default router;
